/**
 * @file automatically generated from MApp.Endpoints.LogContentController
 */ 

import { MetadataClient } from '../metadataClient';
import { ILogMessage, IDeviceLogMessage } from '../models';

export class LogContentClient extends MetadataClient {

    public static getLogs() {
        return MetadataClient.ajax<ILogMessage[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/logs`)
        );
    }

    public static getDeviceLogs() {
        return MetadataClient.ajax<IDeviceLogMessage[]>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/logs/device`)
        );
    }

    public static getLogStackTrace(id: string) {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/logs/${encodeURIComponent(id)}/stacktrace`)
        );
    }

    public static getDeviceLogStackTrace(id: string) {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/logs/device/${encodeURIComponent(id)}/stacktrace`)
        );
    }

    public static deleteLogs() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/logs/all`, {
				method: 'DELETE'
			})
        );
    }

    public static deleteDeviceLogs() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/logs/device/all`, {
				method: 'DELETE'
			})
        );
    }

    public static deleteLog(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/logs/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static deleteDeviceLog(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/logs/device/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static downloadLogs() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/logs/all`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST'
			})
        );
    }

    public static downloadDeviceLogs() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/logs/device/all`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST'
			})
        );
    }

    public static downloadLog(ids: string[]) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/logs`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(ids)
			})
        );
    }

    public static downloadDeviceLog(ids: string[]) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/logs/device`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(ids)
			})
        );
    }
}
